import { apiRequest } from "../services/apiRequest"

export const DashboardUsersApi = {
  create: async (payload) => {
    return await apiRequest(
      "post",
      "/account/admin/dashboard-users/",
      payload,
      { skipCache: true }
    )
  },
  update: async (userId, payload) => {
    return await apiRequest(
      "patch",
      `/account/admin/dashboard-users/${userId}/`,
      payload,
      { skipCache: true }
    )
  },
}
